"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ArrowUp } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GetAQuoteCta() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section id="get-a-quote-cta" className="relative min-h-[70vh] flex items-center justify-center overflow-hidden bg-background py-24">
      {}
      <div className="absolute inset-0 flex items-center justify-center opacity-[0.03] pointer-events-none">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/gwt_watermark_logo.png" alt="" className="w-[600px] h-auto object-contain" aria-hidden="true" />
      </div>

      {}
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        {}
        <div ref={headlineRef} className={`mb-12 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="font-display font-bold text-4xl md:text-5xl lg:text-6xl text-foreground leading-tight tracking-tight">
            Ready to Source Quality Commodities
            <span className="text-accent">.</span>
          </h2>
        </div>

        {}
        <div ref={ctaRef} className={`mb-16 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] delay-100 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <Link to="/ContactPage">
            <Button size="lg" className="bg-primary text-white px-12 py-6 text-lg font-display font-semibold rounded-sm shadow-soft hover:bg-accent hover:shadow-medium hover:scale-[1.02] active:bg-accent-active active:scale-100 transition-all duration-[var(--duration-fast)] ease-linear focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2">
              Request a Quote
            </Button>
          </Link>
        </div>

        {}
        <div className="flex justify-center">
          <Link to="#" className="group">
            <div className="flex flex-col items-center gap-2 text-muted-foreground hover:text-foreground transition-colors duration-[var(--duration-medium)]">
              <div className="w-10 h-10 rounded-full border-2 border-current flex items-center justify-center group-hover:-translate-y-1 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
                <ArrowUp className="w-5 h-5" />
              </div>
              <span className="text-sm font-sans">Back to top</span>
            </div>
          </Link>
        </div>
      </div>
    </section>;
}